import styled from 'styled-components'

export const Container = styled.div`
	min-height: 82vh;

	main {
		padding: 35px 50px 35px 90px;

		.card {
			> h1 {
				margin: 0 8px;
			}

			> p {
				margin-top: 10px;
				margin-bottom: 18px;
				margin-left: 9px;
			}
		}

		@media(max-width: 600px) {
			padding: 35px 50px;
		}

		@media(max-width: 440px) {
			padding: 20px 0;
		}
	}
`

export const ModalInicioFimAtividade = styled.div.attrs({
	className: 'atividade-container'
})`
	form {
		display: flex;
		flex-direction: column;
		width: 100%;

		> p {
			margin: 12px 8px 20px;
			width: 100%;
		}

		.field {
			max-width: 400px;
			align-self: center;
		}

		> button {
			max-width: 200px;
			align-self: center;
		}
	}
`
